import styled from 'styled-components';
import theme from '../theme';

export const PanelCard = styled.div`
  font-family: ${theme.typography.fontFamily};
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.xl};
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;

export const PanelTitle = styled.h2`
  font-size: ${theme.typography.h3.size};
  font-weight: 700;
  color: ${theme.colors.text};
  margin: 0;
  flex: 1;
  min-width: 0;
`;

export const ProgressDots = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;

  ${theme.media.mobile} {
    display: none;
  }
`;

export const Dot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: ${theme.radii.full};
  background: ${({ $state }) =>
    $state === 'done' ? theme.colors.primary
      : $state === 'current' ? theme.colors.warning
        : theme.colors.border};
`;

export const HeaderButton = styled.button`
  font-family: ${theme.typography.fontFamily};
  background: none;
  border: none;
  color: ${theme.colors.textMuted};
  font-size: ${theme.typography.small.size};
  cursor: pointer;
  padding: 2px 4px;

  &:hover {
    color: ${theme.colors.textSecondary};
  }
`;

export const PanelBody = styled.div`
  margin-top: ${theme.spacing.md};
`;

export const SlotRow = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  align-items: flex-start;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.radii.sm};
  margin-bottom: ${theme.spacing.xs};
  ${({ $next }) => $next && `
    background: ${theme.colors.primaryGhost};
    border-left: 3px solid ${theme.colors.primary};
  `}
  ${({ $locked }) => $locked && 'opacity: 0.55;'}
`;

export const SlotMark = styled.span`
  font-size: 15px;
  line-height: 1.4;
  width: 20px;
  text-align: center;
  color: ${({ $done }) => ($done ? theme.colors.success : theme.colors.textMuted)};
`;

export const SlotContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SlotTitle = styled.div`
  font-size: ${theme.typography.body.size};
  font-weight: 600;
  color: ${({ $done }) => ($done ? theme.colors.textMuted : theme.colors.text)};
  ${({ $done }) => $done && 'text-decoration: line-through;'}
`;

export const SlotMeta = styled.div`
  font-size: ${theme.typography.small.size};
  color: ${theme.colors.textSecondary};
  margin-top: 2px;
`;

export const SlotActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  align-items: center;
  margin-top: ${theme.spacing.sm};
  flex-wrap: wrap;
`;

export const PrimaryCta = styled.button`
  font-family: ${theme.typography.fontFamily};
  background: ${theme.colors.primary};
  color: #fff;
  border: none;
  border-radius: ${theme.radii.sm};
  padding: 8px 14px;
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  cursor: pointer;
  transition: background ${theme.transitions.fast};

  &:hover {
    background: ${theme.colors.primaryLight};
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const SecondaryCta = styled.button`
  font-family: ${theme.typography.fontFamily};
  background: none;
  color: ${theme.colors.primary};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.radii.sm};
  padding: 7px 12px;
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${theme.colors.primaryGhost};
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const DisclosureButton = styled.button`
  font-family: ${theme.typography.fontFamily};
  background: none;
  border: none;
  color: ${theme.colors.primary};
  font-size: ${theme.typography.small.size};
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
`;

export const DoneBanner = styled.div`
  font-size: ${theme.typography.body.size};
  color: ${theme.colors.text};
  background: ${theme.colors.successLight};
  border: 1px solid ${theme.colors.success};
  border-radius: ${theme.radii.sm};
  padding: ${theme.spacing.md};
  margin-top: ${theme.spacing.md};
`;

export const PanelFooter = styled.div`
  margin-top: ${theme.spacing.sm};
  padding-top: ${theme.spacing.sm};
  border-top: 1px solid ${theme.colors.borderLight};
  font-size: ${theme.typography.small.size};
  color: ${theme.colors.textMuted};

  a {
    color: ${theme.colors.primary};
  }
`;
